import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "@/auth/auth-context";
import { initializeMixpanel } from "@/setup/events";
import { queryClient } from "@/setup/react-query";
import { GlobalNotification } from "@/ui/global-notification";
import { TooltipProvider } from "@/ui/tooltip";

import { AppRoutes } from "./routes";

export const App = () => {
  useEffect(() => {
    void initializeMixpanel();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <TooltipProvider>
            <GlobalNotification />
            <AppRoutes />
          </TooltipProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};
